import { render, staticRenderFns } from "./costHelpSixtyTage.vue?vue&type=template&id=ddd27974&"
import script from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddd27974')) {
      api.createRecord('ddd27974', component.options)
    } else {
      api.reload('ddd27974', component.options)
    }
    module.hot.accept("./costHelpSixtyTage.vue?vue&type=template&id=ddd27974&", function () {
      api.rerender('ddd27974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QqgahwH2wRWz/JS/costHelpSixtyTage.vue"
export default component.exports